import React from "react";

import Box from "@mui/material/Box";

import { UnclaimedClaimsList } from "./UnclaimedClaimsList";

export const Management = () => {
  return (
    <Box>
      <UnclaimedClaimsList />
    </Box>
  );
};
